import { render, staticRenderFns } from "./BlockContainer.vue?vue&type=template&id=60fd5a40"
import script from "./BlockContainer.vue?vue&type=script&lang=js"
export * from "./BlockContainer.vue?vue&type=script&lang=js"
import style0 from "./BlockContainer.vue?vue&type=style&index=0&id=60fd5a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports